module.exports = __webpack_public_path__ + "static/img/rank_68.3a61415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_68.png
// module id = AzHq
// module chunks = 0